import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { logoutAPI } from "../api/api";

const NAV_ITEMS = [
  {
    key: "overview",
    path: "/dashboard",
    label: "Overview",
    icon: "👁️",
    roles: [],
  },
  {
    key: "zone-overview",
    path: "/cities-overview",
    label: "Zone Overview",
    icon: "🏙️",
    roles: [],
  },
  {
    key: "sales-overview",
    path: "/sales-overview",
    label: "Sales Overview",
    icon: "🎯",
    roles: ["manager"],
  },
  // {
  //   key: "analytics",
  //   path: "/page-under-dev",
  //   label: "Analytics",
  //   icon: "📈",
  //   roles: [],
  // },
  // {
  //   key: "operations",
  //   path: "/page-under-dev",
  //   label: "Operations",
  //   icon: "📊",
  //   roles: [],
  // },
  // {
  //   key: "finance",
  //   path: "/page-under-dev",
  //   label: "Finance",
  //   icon: "💰",
  //   roles: [],
  // },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const username = (localStorage.getItem("username") || "").toLowerCase();
  const isFullAccess =
    username === "chairman" ||
    username === "stockadmin" ||
    username === "manager";

  const MANAGER_USERNAMES = [
"rajini",
  "rajesh",
  "balaji",
  "magesh",
  "rajasekar",
  "saravanan",
  "mageshkumar",
  "esakiraj",
  ];
  const isManager = MANAGER_USERNAMES.includes(username);

  const visibleNavItems = NAV_ITEMS.filter((item) => {
    if (isFullAccess) return true;
    if (isManager) return item.roles.includes("manager");

    return false;
  });

  const handleLogout = async () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      try {
        await logoutAPI();
        navigate("/");
      } catch (error) {
        console.error("Logout error:", error);
        alert("Logout failed. Please try again.");
      }
    }
  };

  return (
    <>
      <style>{`
        @keyframes logoPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.4), 0 4px 14px rgba(0,0,0,0.3); }
          50%       { box-shadow: 0 0 0 8px rgba(0, 212, 255, 0), 0 4px 14px rgba(0,0,0,0.3); }
        }
        @keyframes logoSpin {
          from { transform: rotateY(0deg); }
          to   { transform: rotateY(360deg); }
        }
        @keyframes logoFloat {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-4px); }
        }
        .logo-wrap {
          animation: logoPulse 2.5s ease-in-out infinite, logoFloat 3s ease-in-out infinite;
          transition: all 0.3s ease;
        }
        .logo-wrap:hover {
          animation: logoSpin 0.8s ease-in-out;
          filter: brightness(1.15) drop-shadow(0 0 10px rgba(0,212,255,0.6));
        }
        .nav-link {
          cursor: pointer;
          padding: 12px 10px;
          border-radius: 8px;
          transition: all 0.2s ease;
          font-size: 13px;
          font-weight: 500;
          text-align: center;
          user-select: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
          width: 100%;
          color: rgba(255,255,255,0.65);
          border-left: 3px solid transparent;
        }
        .nav-link:hover {
          background: rgba(255,255,255,0.1);
          color: white;
          border-left-color: #00d4ff;
          transform: translateX(3px);
        }
        .nav-link.active-nav {
          background: rgba(255,255,255,0.15);
          color: white;
          border-left-color: #00d4ff;
        }
        .toggle-btn {
          padding: 7px;
          background: rgba(255,255,255,0.08);
          color: white;
          border: 1px solid rgba(255,255,255,0.12);
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          transition: all 0.3s ease;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .toggle-btn:hover { background: rgba(255,255,255,0.18); }
        .logout-btn {
          padding: 10px;
          background: #ef4444;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          transition: all 0.2s ease;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }
        .logout-btn:hover { background: #dc2626; transform: scale(1.03); }
        .sidebar-divider {
          width: 100%;
          height: 1px;
          background: rgba(255,255,255,0.1);
          flex-shrink: 0;
        }
        .company-name {
          font-size: 11px;
          font-weight: 600;
          text-align: center;
          color: rgba(255,255,255,0.8);
          margin: 0;
          line-height: 1.3;
          word-break: break-word;
        }
      `}</style>

      <div
        style={{
          width: isCollapsed ? 72 : 148,
          height: "100vh",
          background:
            "linear-gradient(180deg, #0a2558 0%, #0f3a7d 55%, #1e5ba8 100%)",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
          padding: "18px 10px 16px",
          borderRight: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "4px 0 20px rgba(0,0,0,0.2)",
          flexShrink: 0,
          overflow: "hidden",
          transition: "width 0.3s ease",
          boxSizing: "border-box",
          zIndex: 10,
        }}
      >
        <div
          className="logo-wrap"
          style={{
            width: isCollapsed ? 46 : 62,
            height: isCollapsed ? 46 : 62,
            borderRadius: "14px",
            background:
              "linear-gradient(135deg, rgba(0,212,255,0.15) 0%, rgba(0,153,204,0.1) 100%)",
            border: "2px solid rgba(0,212,255,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            overflow: "hidden",
            transition: "width 0.3s ease, height 0.3s ease",
          }}
        >
          <img
            src="https://lco.dmtechnologies.in/we-logoh.png"
            style={{
              width: "80%",
              height: "80%",
              objectFit: "contain",
              filter: "brightness(1.1)",
            }}
            alt="Logo"
          />
        </div>

        {!isCollapsed && (
          <p className="company-name">
            Chairman
            <br />
            Desk
          </p>
        )}

        <div className="sidebar-divider" />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            flex: 1,
            width: "100%",
          }}
        >
          {visibleNavItems.map((item) => (
            <div
              key={item.key}
              className={`nav-link${location.pathname === item.path ? " active-nav" : ""}`}
              title={item.label}
              onClick={() => navigate(item.path)}
              style={!isCollapsed ? { padding: "8px 10px", gap: 3 } : undefined}
            >
              <span style={{ fontSize: isCollapsed ? "18px" : "14px" }}>
                {item.icon}
              </span>
              {!isCollapsed && (
                <span style={{ fontSize: "11px" }}>{item.label}</span>
              )}
            </div>
          ))}
        </div>

        <button
          className="toggle-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? "Expand" : "Collapse"}
          style={{
            transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ◀
        </button>

        <button className="logout-btn" onClick={handleLogout} title="Logout">
          <span style={{ fontSize: "17px" }}>🚪</span>
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </>
  );
}

// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { logoutAPI } from "../api/api";

// export default function Sidebar() {
//   const navigate = useNavigate();
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const handleLogout = async () => {
//     const confirmed = window.confirm("Are you sure you want to logout?");
//     if (confirmed) {
//       try {
//         await logoutAPI();
//         navigate("/");
//       } catch (error) {
//         console.error("Logout error:", error);
//         alert("Logout failed. Please try again.");
//       }
//     }
//   };

//   return (
//     <>
//       {/* Inject logo animation keyframes */}
//       <style>{`
//         @keyframes logoPulse {
//           0%, 100% { box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.4), 0 4px 14px rgba(0,0,0,0.3); }
//           50%       { box-shadow: 0 0 0 8px rgba(0, 212, 255, 0), 0 4px 14px rgba(0,0,0,0.3); }
//         }
//         @keyframes logoSpin {
//           from { transform: rotateY(0deg); }
//           to   { transform: rotateY(360deg); }
//         }
//         @keyframes logoFloat {
//           0%, 100% { transform: translateY(0px); }
//           50%       { transform: translateY(-4px); }
//         }
//         .logo-wrap {
//           animation: logoPulse 2.5s ease-in-out infinite, logoFloat 3s ease-in-out infinite;
//           transition: all 0.3s ease;
//         }
//         .logo-wrap:hover {
//           animation: logoSpin 0.8s ease-in-out;
//           filter: brightness(1.15) drop-shadow(0 0 10px rgba(0,212,255,0.6));
//         }
//         .nav-link {
//           cursor: pointer;
//           padding: 12px 10px;
//           border-radius: 8px;
//           transition: all 0.2s ease;
//           font-size: 13px;
//           font-weight: 500;
//           text-align: center;
//           user-select: none;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 5px;
//           width: 100%;
//           color: rgba(255,255,255,0.65);
//           border-left: 3px solid transparent;
//         }
//         .nav-link:hover {
//           background: rgba(255,255,255,0.1);
//           color: white;
//           border-left-color: #00d4ff;
//           transform: translateX(3px);
//         }
//         .nav-link.active-nav {
//           background: rgba(255,255,255,0.15);
//           color: white;
//           border-left-color: #00d4ff;
//         }
//         .toggle-btn {
//           padding: 7px;
//           background: rgba(255,255,255,0.08);
//           color: white;
//           border: 1px solid rgba(255,255,255,0.12);
//           border-radius: 6px;
//           cursor: pointer;
//           font-size: 13px;
//           transition: all 0.3s ease;
//           width: 100%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }
//         .toggle-btn:hover { background: rgba(255,255,255,0.18); }
//         .logout-btn {
//           padding: 10px;
//           background: #ef4444;
//           color: white;
//           border: none;
//           border-radius: 8px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           transition: all 0.2s ease;
//           width: 100%;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           gap: 5px;
//         }
//         .logout-btn:hover { background: #dc2626; transform: scale(1.03); }
//         .sidebar-divider {
//           width: 100%;
//           height: 1px;
//           background: rgba(255,255,255,0.1);
//           flex-shrink: 0;
//         }
//         .company-name {
//           font-size: 11px;
//           font-weight: 600;
//           text-align: center;
//           color: rgba(255,255,255,0.8);
//           margin: 0;
//           line-height: 1.3;
//           word-break: break-word;
//         }
//       `}</style>

//       <div style={{
//         width: isCollapsed ? 72 : 148,
//         height: "100vh",
//         background: "linear-gradient(180deg, #0a2558 0%, #0f3a7d 55%, #1e5ba8 100%)",
//         color: "white",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         gap: 10,
//         padding: "18px 10px 16px",
//         borderRight: "1px solid rgba(255,255,255,0.08)",
//         boxShadow: "4px 0 20px rgba(0,0,0,0.2)",
//         flexShrink: 0,
//         overflow: "hidden",
//         transition: "width 0.3s ease",
//         boxSizing: "border-box",
//         zIndex: 10,
//       }}>

//         {/* Animated Logo */}
//         <div className="logo-wrap" style={{
//           width: isCollapsed ? 46 : 62,
//           height: isCollapsed ? 46 : 62,
//           borderRadius: "14px",
//           background: "linear-gradient(135deg, rgba(0,212,255,0.15) 0%, rgba(0,153,204,0.1) 100%)",
//           border: "2px solid rgba(0,212,255,0.35)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexShrink: 0,
//           overflow: "hidden",
//           transition: "width 0.3s ease, height 0.3s ease",
//         }}>
//           <img
//             src="https://lco.dmtechnologies.in/we-logoh.png"
//             style={{
//               width: "80%",
//               height: "80%",
//               objectFit: "contain",
//               filter: "brightness(1.1)",
//             }}
//             alt="Logo"
//           />
//         </div>

//         {!isCollapsed && <p className="company-name">Chairman<br/>Desk</p>}

//         <div className="sidebar-divider" />

//         {/* Nav Links */}
//         <div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1, width: "100%" }}>
//           <div className="nav-link active-nav" title="Overview">
//             <span style={{ fontSize: "18px" }}>👁️</span>
//             {!isCollapsed && <span>Overview</span>}
//           </div>
//           <div className="nav-link" title="Operations">
//             <span style={{ fontSize: "18px" }}>📊</span>
//             {!isCollapsed && <span>Operations</span>}
//           </div>
//           <div className="nav-link" title="Finance">
//             <span style={{ fontSize: "18px" }}>💰</span>
//             {!isCollapsed && <span>Finance</span>}
//           </div>
//         </div>

//         {/* Toggle Collapse */}
//         <button
//           className="toggle-btn"
//           onClick={() => setIsCollapsed(!isCollapsed)}
//           title={isCollapsed ? "Expand" : "Collapse"}
//           style={{ transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease" }}
//         >
//           ◀
//         </button>

//         {/* Logout */}
//         <button className="logout-btn" onClick={handleLogout} title="Logout">
//           <span style={{ fontSize: "17px" }}>🚪</span>
//           {!isCollapsed && <span>Logout</span>}
//         </button>

//       </div>
//     </>
//   );
// }
